import React from "react"
import { Field } from "redux-form"
import { Flex } from "src/components/Grid"
import RadioTemp from "src/components/RadioTemp"
import { Caption } from "@infotech/uikit-text"
import styles from "../styles.css"

/* eslint-disable jsx-a11y/label-has-for  */
/* eslint-disable jsx-a11y/label-has-associated-control  */
export default props => {
  const { name, errorLabel, errorValue, warningLabel, warningValue } = props

  return (
    <Flex column>
      <label className={styles.violationLabel}>
        <Caption.Blocky>Выводить:</Caption.Blocky>
      </label>
      <label className={styles.violationOptionLabel}>
        <Field
          name={name}
          component={RadioTemp}
          type="radio"
          value={errorValue}
        />
        {errorLabel}
      </label>
      <label className={styles.violationOptionLabel}>
        <Field
          name={name}
          component={RadioTemp}
          type="radio"
          value={warningValue}
        />
        {warningLabel}
      </label>
    </Flex>
  )
}
